import TOKEN from '../TOKEN';

const createUnorderedItem =
  (context) =>
  ({ 0: text, 1: newline, 2: padding, index }) => ({
    type: TOKEN.UNORDERED_ITEM,
    text: text.slice(newline.length),
    index: index + newline.length,
  });

createUnorderedItem.regex = /(^|\n)(\s*)[-*]\s/g;

export default createUnorderedItem;
